import React, { useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';


import Header from './Components/Header';
import Alert from './Components/Alert';
import Home from './Components/Home';
import Login from './Components/Login';
import Dashboard from './Components/Dashboard';
import ErrorPage from './Components/ErrorPage';
import Products from './Components/Products';
import ContactForm from './Components/ContactForm';
import Footer from './Components/Footer';
 

const App = () => {
  const [authToken, setAuthToken] = useState(localStorage.getItem('token'));
  const apiUrl = process.env.REACT_APP_API_URL;

  return (
    <BrowserRouter>
      <Header />
      <Alert />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login setAuthToken={setAuthToken} apiUrl={apiUrl} />} />
        {authToken ? (
          <Route path="/dashboard/*" element={<Dashboard apiUrl={apiUrl} />} />
        ) : (
          <Route path="/dashboard/*" element={<Navigate to="/error" />} />
        )}
        <Route path="/error" element={<ErrorPage />} />
        <Route path="/products/*" element={<Products apiUrl={apiUrl} />} />
        <Route path="/contact" element={<ContactForm apiUrl={apiUrl} />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
